import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createTerm,
  getTerms,
  getTerm,
  updateTerm,
  deleteTerm,
} from './termApi';
import { toast } from 'react-toastify';

// Hook to create a new term
export const useCreateTerm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTerm,
    mutationKey: ['createTerm'],
    onSuccess: () => {
      toast.success('Term created successfully');
      queryClient.invalidateQueries('terms');
    },
    onError: (error) => {
      console.error('Error creating term:', error);
      toast.error(error.response?.data?.message || 'Failed to create term');
    },
  });
};

// Hook to get all terms
export const useGetTerms = () => {
  return useQuery('terms', getTerms);
};

// Hook to get details of a specific term
export const useGetTerm = (termId) => {
  return useQuery(['term', termId], () => getTerm(termId), {
    enabled: !!termId,
  });
};

// Hook to update a term
export const useUpdateTerm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['updateTerm'],
    mutationFn: ({ termId, termData }) => updateTerm(termId, termData),
    onSuccess: () => {
      queryClient.invalidateQueries('terms');
      toast.success('Term updated successfully');
    },
    onError: (error) => {
      console.error('Error updating term:', error);
      toast.error(error.response?.data?.message || 'Failed to update term');
    },
  });
};

// Hook to delete a term
export const useDeleteTerm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTerm,
    onSuccess: () => {
      queryClient.invalidateQueries('terms');
      toast.success('Term deleted successfully');
    },
    onError: (error) => {
      console.error('Error deleting term:', error);
      toast.error(error.response?.data?.message || 'Failed to delete term');
    },
  });
};
